import { useState, useEffect } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';

export interface Testimonial {
  id: string;
  imageUrl: string;
  name?: string;
  isActive: boolean;
  order?: number;
  createdAt: any;
}

export const useTestimonials = () => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const testimonialsRef = collection(db, 'testimonials');
      const q = query(testimonialsRef);

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const testimonialsData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          })) as Testimonial[];

          // Filter active testimonials and sort by order field or createdAt
          const activeTestimonials = testimonialsData
            .filter(testimonial => testimonial.isActive === true)
            .sort((a, b) => {
              if (a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
              }
              return (b.createdAt?.toDate?.() || new Date()) - (a.createdAt?.toDate?.() || new Date());
            });

          console.log('Testimonials loaded:', activeTestimonials.length, activeTestimonials);
          setTestimonials(activeTestimonials);
          setLoading(false);
        },
        (err) => {
          console.error('Error fetching testimonials:', err);
          setError('Failed to load testimonials');
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (err) {
      console.error('Error setting up testimonials listener:', err);
      setError('Failed to setup testimonials listener');
      setLoading(false);
    }
  }, []);

  return { testimonials, loading, error };
};